var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 1.73375L3.09 3.61375C1.94 4.04375 1 5.40375 1 6.62375V14.0538C1 15.2338 1.78 16.7838 2.73 17.4938L7.03 20.7038C8.44 21.7638 10.76 21.7638 12.17 20.7038L16.47 17.4938C17.42 16.7838 18.2 15.2338 18.2 14.0538V6.62375C18.2 5.39375 17.26 4.03375 16.11 3.60375L11.12 1.73375C10.27 1.42375 8.91 1.42375 8.08 1.73375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64001 11.3737L8.25001 12.9837L12.55 8.68375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatoryWhite);
export default __webpack_public_path__ + "static/media/regulatoryWhite.e0d03fb2b6bdfdc6e4b56497bf8d0e6b.svg";
export { ForwardRef as ReactComponent };